module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "front"
  }, [_c('v-app', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "inspire"
    }
  }, [(_vm.$route.meta.showNav) ? _c('NavBar') : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41c7dc64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Layout/Front.vue
// module id = 609
// module chunks = 1